import axios from './../../mixins/axios'
import display from '@/mixins/display.js'
export default {
  mixins: [display],
  data() {
    return {
      page: 1,
      pagesize: 10,
      total: 0,
      isUpdate: true,
      nodeVersion: '', //节点版本兼容
      //address信息
      addressInfo: {
        adr: this.$route.query.address,
        balance: 0,
        reciver: 0,
        txCount: 0,
      },
      SuccessToken: [],
      TokenBalance: [],
      BalanceSelect: '',
      totalValue: 0,
      //交易列表
      isloading: false,
      chooseToken: '全部',
      selectTokenSymbol: [{
        'symbol': '全部',
        'icon': ''
      }],
      chooseSymbol: {
        'symbol': '全部'
      },
      coin: require('../../assets/images/img/coin.png'),
      coinIcons: [],
      pageType: 1,
      firstTrade: '',
      lastTrade: '',
      TableList: [],
    }
  },
  watch: {
    $route() {
      //参数进行初始化
      this.TokenBalance = [];
      this.BalanceSelect = '',
        this.chooseToken = '全部';
      this.selectTokenSymbol = [{
        'symbol': '全部',
        'icon': ''
      }];
      this.chooseSymbol = {
        'symbol': '全部'
      };
      this.totalValue = 0;
      this.addressInfo = {
        adr: this.$route.query.address,
        balance: 0,
        reciver: 0,
        txCount: 0,
      };
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  computed: {
    provider() {
      return this.$store.state.apiSetting.provider
    },
    execer() {
      return this.$store.state.apiSetting.execer
    },
  },
  methods: {
    goAddress(adr) {
      if (adr) {
        this.$router.push(`/addressDetail?address=${adr}`)
      } else {
        Toast('地址不合法')
      }
    },
    reload() {
      this.getBalance()
      this.getTransactions()
    },
    async getBalance() {
      this.isloading = true;
      const { data: _data } = await axios.get(
        "/api/v1/transaction/balance?miner=" + this.addressInfo.adr
      );
      this.isloading = false;
      this.addressInfo.balance = _data.Balance/1000000000000000000;
      this.addressInfo.TransCount = _data.TransCount;
    },
    async getTransactions() {
      const { data: _data } = await axios.get(
        "/api/v1/transaction/miner?miner=" + this.addressInfo.adr + "&page=" + this.page
      );
      this.TableList = _data.transactions;
      this.total = _data.page_count;
    },
    success(){
      this.$message.success('复制成功')
    },
    // 换页
    pagechange() {
      // 换页后清除定时器
      clearTimeout(this.getLastHeightTime)
      this.isUpdate = false
      this.txList = []
      this.getTransactions()
    },
    // 导出excel
    exportExcel() {
      //列标题，逗号隔开，每一个逗号就是隔开一个单元格
      let str = `姓名,电话,邮箱\n`;
      //增加\t为了不让表格显示科学计数法或者其他格式
      for (let i = 0; i < this.TableList.length; i++) {
        for (let item in this.TableList[i]) {
          str += `${this.TableList[i][item] + '\t'},`;
        }
        str += '\n';
      }
      //encodeURIComponent解决中文乱码
      let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
      //通过创建a标签实现
      let link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = "json数据表.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}